const cloud = [
  {
    id: 'a1',
    name: 'A1',
    plan: 'A1',
    title: 'A1',
    subTitle: '',
    price: 100000,
    beforePrice: 150000,
    totalMonths: 0,
    description: ['Mua 30 ngày treo tài khoản & 30k điểm', 'Chỉ View (không chạy Like & Follow)'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/subcheo.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'a2',
    name: 'A2',
    plan: 'A2',
    title: 'A2',
    subTitle: '',
    price: 200000,
    beforePrice: 350000,
    totalMonths: 0,
    description: ['Mua 45 ngày treo tài khoản & 100k điểm', 'Chỉ View (không chạy Like & Follow)'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/subcheo.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'a3',
    name: 'A3',
    plan: 'A3',
    title: 'A3',
    subTitle: '',
    price: 300000,
    beforePrice: 600000,
    totalMonths: 0,
    description: ['Mua 120 ngày treo tài khoản & 10k điểm', 'Chỉ View (không chạy Like & Follow)'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/subcheo.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'a4',
    name: 'A4',
    plan: 'A4',
    title: 'A4',
    subTitle: '',
    price: 400000,
    beforePrice: 800000,
    totalMonths: 0,
    description: ['Mua 60 ngày treo tài khoản & 300k điểm', 'Chỉ View (không chạy Like & Follow)'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/subcheo.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'a5',
    name: 'A5',
    plan: 'A5',
    title: 'A5',
    subTitle: '',
    price: 500000,
    beforePrice: 1200000,
    totalMonths: 0,
    description: ['Mua 90 ngày treo tài khoản & 500k điểm', 'Chỉ View (không chạy Like & Follow)'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/subcheo.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'a6',
    name: 'A6',
    plan: 'A6',
    title: 'A6',
    subTitle: '',
    price: 700000,
    beforePrice: 1800000,
    totalMonths: 0,
    description: ['Mua 120 ngày treo tài khoản & 800k điểm', 'Chỉ View (không chạy Like & Follow)'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/subcheo.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'a7',
    name: 'A7',
    plan: 'A7',
    title: 'A7',
    subTitle: '',
    price: 800000,
    beforePrice: 2400000,
    totalMonths: 0,
    description: ['Mua 150 ngày treo tài khoản & 1tr200k điểm', 'Chỉ View (không chạy Like & Follow)'],
    promotion: [],
    hotPrice: '',
    bestChoice: true,
    logo: '/img/subcheo.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'a8',
    name: 'A8',
    plan: 'A8',
    title: 'A8',
    subTitle: '',
    price: 1000000,
    beforePrice: 3000000,
    totalMonths: 0,
    description: ['Mua 180 ngày treo tài khoản & 1tr600k điểm', 'Chỉ View (không chạy Like & Follow)'],
    promotion: [],
    hotPrice: '',
    bestChoice: true,
    logo: '/img/subcheo.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
];

const score = [
  {
    id: 'a1d',
    name: 'A1d',
    plan: 'A1d',
    title: 'A1d',
    subTitle: '',
    price: 100000,
    beforePrice: 150000,
    totalMonths: 0,
    description: ['Mua 150,000 điểm & Không treo tài khoản phụ', 'Chỉ View (không chạy Like & Follow)'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/subcheo.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'a2d',
    name: 'A2d',
    plan: 'A2d',
    title: 'A2d',
    subTitle: '',
    price: 200000,
    beforePrice: 350000,
    totalMonths: 0,
    description: ['Mua 350k điểm & Không treo tài khoản phụ', 'Chỉ View (không chạy Like & Follow)'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/subcheo.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'a3d',
    name: 'A3d',
    plan: 'A3d',
    title: 'A3d',
    subTitle: '',
    price: 300000,
    beforePrice: 600000,
    totalMonths: 0,
    description: ['Mua 600k điểm & Không treo tài khoản phụ', 'Chỉ View (không chạy Like & Follow)'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/subcheo.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'a4d',
    name: 'A4d',
    plan: 'A4d',
    title: 'A4d',
    subTitle: '',
    price: 400000,
    beforePrice: 800000,
    totalMonths: 0,
    description: ['Mua 800k điểm & Không treo tài khoản phụ', 'Chỉ View (không chạy Like & Follow)'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/subcheo.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'a5d',
    name: 'A5d',
    plan: 'A5d',
    title: 'A5d',
    subTitle: '',
    price: 500000,
    beforePrice: 1200000,
    totalMonths: 0,
    description: ['Mua 1tr200k điểm & Không treo tài khoản phụ', 'Chỉ View (không chạy Like & Follow)'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/subcheo.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'a6d',
    name: 'A6d',
    plan: 'A6d',
    title: 'A6d',
    subTitle: '',
    price: 700000,
    beforePrice: 1800000,
    totalMonths: 0,
    description: ['Mua 1tr800k điểm & Không treo tài khoản phụ', 'Chỉ View (không chạy Like & Follow)'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/subcheo.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'a7d',
    name: 'A7d',
    plan: 'A7d',
    title: 'A7d',
    subTitle: '',
    price: 800000,
    beforePrice: 2400000,
    totalMonths: 0,
    description: ['Mua 2tr400k điểm & Không treo tài khoản phụ', 'Chỉ View (không chạy Like & Follow)'],
    promotion: [],
    hotPrice: '',
    bestChoice: true,
    logo: '/img/subcheo.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'a8d',
    name: 'A8d',
    plan: 'A8d',
    title: 'A8d',
    subTitle: '',
    price: 1000000,
    beforePrice: 3000000,
    totalMonths: 0,
    description: ['Mua 3tr điểm & Không treo tài khoản phụ', 'Chỉ View (không chạy Like & Follow)'],
    promotion: [],
    hotPrice: '',
    bestChoice: true,
    logo: '/img/subcheo.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
];

export default {
  cloud,
  score,
};
